import React, { Component } from "react";
import { object, string } from "prop-types";

import _ from "lodash";
import keys from "lodash/keys";
import Grid from "@material-ui/core/Grid";
import Widget from "../../../../legacy-tv-ui/Widget";
import Table from "../../../../legacy-tv-ui/Table";
import Td from "../../../../legacy-tv-ui/Td";
import Tr from "../../../../legacy-tv-ui/Tr";
import Th from "../../../../legacy-tv-ui/Th";
import Return from "../../../../legacy-tv-ui/Return";
import Footnote from "../../../../components/Footnote";
import { toPercentage } from "../../../../utils";

const KEYS = ["YTM", "_1m", "_3m", "_6m", "_12m", "1yVol", "1mVol"];

export class SummaryTable extends Component {
  static propTypes = {
    data: object,
    footnote: string,
  };
  static defaultProps = {
    data: [],
    footnote: "",
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  sortKeys = (keys) => {
    const ret = [];
    const expect = ["短期", "中期", "長期"];
    for (let key of expect) {
      if (keys.indexOf(key) >= 0) {
        ret.push(key);
      }
    }
    for (let key of keys) {
      if (expect.indexOf(key) < 0) {
        ret.push(key);
      }
    }
    return ret;
  };
  render() {
    const [firstKey, secondKey, thirdKey] = this.sortKeys(
      keys(this.props.data.rr3._1m)
    );

    console.log(
      "data %o, vs %o, %o",
      keys(this.props.data),
      this.props.keys,
      this.props.data.rr3._1m
    );
    console.log({ firstKey, secondKey, thirdKey });
    return (
      <Grid
        item
        xs={12}
        lg={9}
        style={{
          padding: 20,
        }}
      >
        <Widget title="投資組合 - 近期績效">
          <Table style={{ width: "100%" }}>
            <thead>
              <Tr>
                <Th colSpan="2" />
                <Th>YTM</Th>
                <Th>1 month</Th>
                <Th>3 month</Th>
                <Th>6 month</Th>
                <Th>12 month</Th>
                <Th>1 year vol</Th>
                {!_.isEmpty(this.props.data.rr3["1mVol"]) && (
                  <Th>1 month vol</Th>
                )}
              </Tr>
            </thead>
            <tbody>
              {this.props.keys
                .filter((key) => key !== "summary")
                .map((rr) => {
                  const highRow = (
                    <Tr key={rr + "high"}>
                      <Td rowSpan="3">{rr.toUpperCase()}</Td>
                      <Td>
                        {firstKey.substr(0, 1).toUpperCase() +
                          firstKey.substr(1).toLowerCase()}
                      </Td>
                      {KEYS.map((row) => {
                        if (!_.isEmpty(this.props.data[rr][row])) {
                          if (row === "1yVol" || row === "1mVol") {
                            return (
                              <Td
                                key={row}
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {toPercentage(
                                  this.props.data[rr][row][firstKey]
                                )}
                              </Td>
                            );
                          }
                          return (
                            <Td key={row} style={{ textAlign: "center" }}>
                              <Return
                                rtn={this.props.data[rr][row][firstKey]}
                              />
                            </Td>
                          );
                        }
                        return null;
                      })}
                    </Tr>
                  );
                  const midRow = (
                    <Tr key={rr + "mid"}>
                      <Td>
                        {secondKey.substr(0, 1).toUpperCase() +
                          secondKey.substr(1).toLowerCase()}
                      </Td>
                      {KEYS.map((row) => {
                        if (!_.isEmpty(this.props.data[rr][row])) {
                          if (row === "1yVol" || row === "1mVol") {
                            return (
                              <Td
                                key={row}
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {toPercentage(
                                  this.props.data[rr][row][secondKey]
                                )}
                              </Td>
                            );
                          }
                          return (
                            <Td key={row} style={{ textAlign: "center" }}>
                              <Return
                                rtn={this.props.data[rr][row][secondKey]}
                              />
                            </Td>
                          );
                        }
                        return null;
                      })}
                    </Tr>
                  );
                  const lowRow = (
                    <Tr key={rr + "low"}>
                      <Td>
                        {thirdKey.substr(0, 1).toUpperCase() +
                          thirdKey.substr(1).toLowerCase()}
                      </Td>
                      {KEYS.map((row) => {
                        if (!_.isEmpty(this.props.data[rr][row])) {
                          if (row === "1yVol" || row === "1mVol") {
                            return (
                              <Td
                                key={row}
                                style={{
                                  textAlign: "center",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {toPercentage(
                                  this.props.data[rr][row][thirdKey]
                                )}
                              </Td>
                            );
                          }
                          return (
                            <Td key={row} style={{ textAlign: "center" }}>
                              <Return
                                rtn={this.props.data[rr][row][thirdKey]}
                              />
                            </Td>
                          );
                        }
                        return null;
                      })}
                    </Tr>
                  );
                  return [highRow, midRow, lowRow];
                })}
            </tbody>
          </Table>
          {this.props.footnote && <Footnote>{this.props.footnote}</Footnote>}
        </Widget>
      </Grid>
    );
  }
}

export default SummaryTable;



// WEBPACK FOOTER //
// ./src/scenes/Performance/components/SummaryTable/index.js